module.exports = __webpack_public_path__ + "img/7-1.365b959b.svg";